import React, { Component } from 'react';
import './resume.css';
import {data} from "./Content";
import {isMobile} from 'react-device-detect';

class Resume extends Component {

  render() {
      return isMobile ? <Mobile /> : <Desktop />
  }
}

export default Resume;

class Mobile extends Component {
    render() {
        return (
            <div className="pageMobile">

                <div id="photoMobile"><img alt={data.name} id="portrait" src="ashleygrison.jpeg" /></div>
                <div className="contactMobile">
                    <div className="contactItem"><i className="fas fa-home icon"/>{data.contact.city}</div>
                    <div className="contactItem"><i className="fas fa-at icon emailIcon"/>{data.contact.email}</div>
                    <div className="contactItem"><i className="fas fa-mobile-alt icon phoneIcon"/>{data.contact.phone}</div>
                </div>
                <div className="name">{data.name}</div>
                <div id="title">{data.title}</div>
                <About about={data.about} />
                <Experience blocks={data.blocks}/>

                <div style={{clear: 'both'}} />

            </div>
        );
    }
}

class Desktop extends Component {
    render() {
        return (
            <div className="page">

                <div className="left">
                    <div id="photo"><img alt={data.name} id="portrait" src="ashleygrison.jpeg" /></div>
                    <div className="contact">
                        <div className="contactTitle">{data.contact.title}</div>
                        <div className="contactItem"><i className="fas fa-home icon"/>{data.contact.city}</div>
                        <div className="contactItem"><i className="fas fa-at icon emailIcon"/>{data.contact.email}</div>
                        <div className="contactItem"><i className="fas fa-mobile-alt icon phoneIcon"/>{data.contact.phone}</div>
                    </div>
                    <Skills skills={data.skills} />
                </div>

                <div className="right">
                    <div className="name">{data.name}</div>
                    <div id="title">{data.title}</div>
                    <About about={data.about} />
                    <Experience blocks={data.blocks}/>

                    <div style={{clear: 'both'}} />

                </div>

                <div style={{clear: 'both'}} />

            </div>
        );
    }
}

class Skill extends Component {
    constructor(props) {
        super(props);
        this.state = { percentage: 0 };
    }

    tick() {
        if (this.state.percentage < this.props.percentage) {
            this.setState(state => ({
                percentage: state.percentage + 1
            }));
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.tick(), 1);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div className="skill">
                <div className="skillName">{this.props.name}</div>
                <div className="skillValue"><div className="skillBar" style={{width: this.state.percentage + '%',}} /></div>
            </div>
        );
    }
}

class Skills extends Component {
    render() {
        const skillsBlocks = this.props.skills.map((skill, index) => {
            const key = "block" + index;
            return <SkillsBlock skill={skill} key={key} id={key} />
        });
        return <div>
            {skillsBlocks}
        </div>
    }
}

class SkillsBlock extends Component {
    render() {
        const skills = this.props.skill.sets.map((set, index) => {
            const key = this.props.id + ".set" + index;
            return <SkillSet set={set} key={key} id={key} />
        });
        return <div className="skills">
            <SkillsTitle title={this.props.skill.title} />
            {skills}
        </div>
    }
}

class SkillsTitle extends Component {
    render() {
        return <div id="skillsTitle">{this.props.title}</div>
    }
}
class SkillSet extends Component {
    render() {
        const skills = this.props.set.skills.map((skill, index) => {
            const key = this.props.id + ".skill" + index;
            return <Skill name={skill.name} percentage={skill.percentage} key={key} />
        });
        return <div className="skillSet">
            <SkillSetTitle title={this.props.set.title} />
            {skills}
        </div>
    }
}
class SkillSetTitle extends Component {
    render() {
        return <div className="skillSetTitle">{this.props.title}</div>
    }
}

class Experience extends Component {
    render() {
        const elements = this.props.blocks.map((block, index) => {
            const key = "exp"+index;
            return <Exp key={key} id={key} block={block} />
        });
        return <div>{elements}</div>
    }
}

class Exp extends Component {
    render() {
        const length = this.props.block.items.length;
        const items = this.props.block.items.map((item, index) => {
            const last = length === index + 1;
            const key = this.props.id+".item"+index;
            return <ExpItem key={key} id={key} item={item} last={last} />
        });
        return <div className="xp"><ExpHeader header={this.props.block.title} />{items}</div>;
    }
}

class ExpHeader extends Component {
    render() {
        return <div className="xpHeader">{this.props.header}</div>
    }
}

class ExpItem extends Component {
    render() {
        const titleKey = this.props.id+".title";
        const descKey = this.props.id+".desc";
        return <div className="xpItem">
            <ExpTitle key={titleKey} id={titleKey} title={this.props.item.t1} />
            <ExpDesc key={descKey} id={descKey} desc1={this.props.item.t2} desc2={this.props.item.t3} desc3={this.props.item.t4} last={this.props.last} />
        </div>
    }
}

class ExpTitle extends Component {
    render() {
        return <div className="xpTitle">
            <div className="xpTitleDot"><span className="xpDot"/></div><div className="xpTitleText">{this.props.title}</div>
        </div>
    }
}

class ExpDesc extends Component {
    render() {
        const style = this.props.last ? {borderLeft: 'solid white 3px'} : {};
        const desc2 = this.props.desc2 !== undefined ? <div className="xpTime">{this.props.desc2}</div> : null;
        return <div className="xpDesc">
            <div className="xpDescContent" style={style}>
                <div className="xpCompanyName">{this.props.desc1}</div>
                {desc2}
                <div className="xpDescText">{this.props.desc3}</div>
            </div>
        </div>
    }
}

class About extends Component {
    render() {
        const paragraphs = this.props.about.map((paragraph, index) => {
            const key = "about.p" + index;
            return <p id={"about" + index} key={key}>{paragraph}</p>
        });
        return <div id="about">{paragraphs}</div>
    }
}






// WEBPACK FOOTER //
// ./src/Resume.js